export default {
  100101: 'Order/Reserve/invoice',
  100201: 'Order/Reserve/ownerOrderList',
  100301: 'Order/Reserve/refundsList',
  100401: 'Order/Reserve/consumptionList',
  100501: 'Order/Reserve/invoiceManage',
  100601: 'Advert/Advert/roomSort',
  100701: 'Cleaner/Cleaner/goodsList',
  100801: 'Cleaner/Cleaner/messageList',
  100901: 'Cleaner/Cleaner/functionDistrict',
  101001: 'Cleaner/Cleaner/deductions',
  101101: 'Cleaner/Cleaner/refuseCleanerOrder',
  101201: 'Cleaner/Cleaner/easilyConsumeList',
  101301: 'Cleaner/Cleaner/liveOrderList',
  101401: 'Cleaner/Cleaner/cleanerCharging',
  101501: 'Cleaner/Cleaner/cleanBillList',
  101601: 'Cleaner/Cleaner/housekeeperBillList',
  101701: 'Cleaner/Cleaner/cleanerInsuranceList',
  101801: 'Cleaner/Cleaner/additionalFee',
  101901: 'Cleaner/Cleaner/trainingList',
  102001: 'Market/Market/marketingExcludeRoom',
  102101: 'Order/Reserve/feedback',
  102201: 'BlueHoster/BlueHoster/roomEvaluation',
  102301: 'Cleaner/Cleaner/reportList',
  102401: 'Cleaner/Cleaner/cleanerOrderReport',
  102501: 'Cleaner/Cleaner/cleanerChargingReport',
  102601: 'Report/Report/chainSaleReport',
  102701: 'Order/Reserve/generalizeReport2',
  102801: 'Order/Reserve/orderSettlementReport',
  102901: 'Order/Reserve/orderWaitPayReport',
  103001: 'Report/Report/roomMonthIncomeReport',
  103101: 'Cleaner/Cleaner/roomConsumablesBillList',
  103201: 'Order/Reserve/orderReport',
  103301: 'Advert/Advert/advertList',
  103401: 'Advert/Advert/homeHotCity',
  103501: 'Advert/Advert/recommendRoom',
  103601: 'Advert/Advert/recommendRoom',
  103701: 'Ota/Ota/channelList',
  103801: 'Ota/Ota/channelDetail',
  103901: 'Ota/Ota/xbedChannelHotelList',
  104001: 'Ota/Ota/xbedChannelHotelDetail',
  104101: 'Ota/Ota/xbedChannelRoomTypeDetail',
  104201: 'Ota/Ota/mtChannelHotelList',
  104301: 'Ota/Ota/mtChannelHotelDetail',
  104401: 'Ota/Ota/mtChannelRoomTypeDetail',
  104501: 'Ota/Ota/dynamicRoomPrice',
  104601: 'Ota/Ota/qhhChannelHotelList',
  104701: 'Ota/Ota/qhhChannelHotelDetail',
  104801: 'Ota/Ota/qhhChannelRoomTypeDetail',
  104901: 'Ota/Ota/channelOrderList',
  105001: 'BlueHoster/BlueHoster/newContract',
  105101: 'Order/Reserve/roomStatusEditRecord',
}


// WEBPACK FOOTER //
// ./src/pageCodes.js